import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-main-customers',
  templateUrl: './main-customers.component.html',
  styleUrls: ['./main-customers.component.css']
})
export class MainCustomersComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  dataItem: any = {
    chart: {
      numberPrefix: "R$",
      aligncaptionwithcanvas: "0",
      plottooltext:
        "<b>$dataValue</b>",
      theme: "gammel",
      decimalSeparator: ",",
      thousandSeparator: ".",
      showvalues: "1",
      placevaluesinside: "0",
      palettecolors: "FEC433"
    },
    data: []
  };

  width = '100%';
  height = '300';
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = this.dataItem;

  loading: boolean = false;
  listItem: { label: string, type: number, value: number }[] = [
    { label: "VALOR", type: 0, value: 0},
    { label: "QUANTIDADE", type: 1, value: 1},
  ];
  typeSelected: any = 0;
  orderByQuantity: boolean = false;
  filterStart: any;
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.loading = true;
      let excelInfo: any[] = [];
      this.dataItem.data = [];
      this.filterStart = item;
      this.clientsReturn(item).subscribe((data: any) => {
        data.dataRow.map((el:any) => {
          !this.orderByQuantity
          ? ( 
              this.dataItem.data.push({
                label: el.name,
                value: el.invoiceValue
              }),
              this.dataItem.chart.numberPrefix = 'R$',
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Cliente': el.name, 'Valor': 'R$' + el.invoiceValue.toString()})
            )
          : ( 
            this.dataItem.data.push({
              label: el.name,
              value: el.itemQuantity
            }),
            this.dataItem.chart.numberPrefix = '',
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Cliente': el.name, 'Valor': 'R$' + el.invoiceValue.toString()})
            )
        });
        excelInfo.unshift({});
        localStorage.setItem('main-customers-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_MAIN_CUSTOMERS;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  clientsReturn(item: any) {
    return this.api.postTopCustomersSellerPanel(item.dataMin, item.dataMax, item.branch, this.orderByQuantity);
  }

  selectProduct() {
    return this.api.getClassificationTypes()
  }

  recoverValues(item: any) {
    item === 1
    ? (this.orderByQuantity = true, this.typeSelected = 1)
    : (this.orderByQuantity = false, this.typeSelected = 0)
    this.filterItem(this.filterStart);
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataConditionalConversion = [];
    let objectConditionalConversion = localStorage.getItem('main-customers-sellers');

    objectConditionalConversion != null
      ? (dataConditionalConversion = JSON.parse(objectConditionalConversion))
      : (dataConditionalConversion = []);
    const worksheetConditionalConversion= XLSX.utils.json_to_sheet(dataConditionalConversion);

    const workbook = {
      Sheets: {
        'main-customers': worksheetConditionalConversion,
      },
      SheetNames: [
        'main-customers',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-main-customers' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: conditional-conversion \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
